'use client';

import { c as _c } from "react/compiler-runtime";
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertDescription, AlertTitle } from '@uzh-bf/design-system';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { useCachedBookmarkedBlocksSWR } from '~/app/actions/progress';
import { SupportedLocales } from '~/types';
import BookmarkEntry from './BookmarkEntry';
function SuspendedBookmarksList() {
  const $ = _c(46);
  const t = useTranslations();
  const params = useParams();
  let t0;
  if ($[0] !== params.courseId) {
    t0 = {
      courseId: params.courseId,
      suspense: false
    };
    $[0] = params.courseId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: bookmarks,
    isLoading,
    error
  } = useCachedBookmarkedBlocksSWR(t0);
  if (isLoading) {
    let t1;
    if ($[2] !== t) {
      t1 = t("generic.bookmarks");
      $[2] = t;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== t1) {
      t2 = <h1 className="text-primary text-xl sm:text-2xl font-semibold tracking-tight">{t1}</h1>;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="animate-pulse space-y-3"><div className="h-24 bg-gray-200 rounded" /><div className="h-24 bg-gray-200 rounded" /><div className="h-24 bg-gray-200 rounded" /></div>;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t2) {
      t4 = <div className="flex w-full flex-col gap-3 p-4">{t2}{t3}</div>;
      $[7] = t2;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (error) {
    let t1;
    if ($[9] !== t) {
      t1 = t("generic.bookmarks");
      $[9] = t;
      $[10] = t1;
    } else {
      t1 = $[10];
    }
    let t2;
    if ($[11] !== t1) {
      t2 = <h1 className="text-primary text-xl sm:text-2xl font-semibold tracking-tight">{t1}</h1>;
      $[11] = t1;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    let t3;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Alert variant="destructive"><FontAwesomeIcon icon={faWarning} /><AlertTitle>Error</AlertTitle><AlertDescription>Failed to load bookmarks. Please try again.</AlertDescription></Alert>;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    let t4;
    if ($[14] !== t2) {
      t4 = <div className="flex w-full flex-col gap-3 p-4">{t2}{t3}</div>;
      $[14] = t2;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    return t4;
  }
  if (!bookmarks || bookmarks.length === 0) {
    let t1;
    if ($[16] !== t) {
      t1 = t("generic.bookmarks");
      $[16] = t;
      $[17] = t1;
    } else {
      t1 = $[17];
    }
    let t2;
    if ($[18] !== t1) {
      t2 = <h1 className="text-primary text-xl sm:text-2xl font-semibold tracking-tight">{t1}</h1>;
      $[18] = t1;
      $[19] = t2;
    } else {
      t2 = $[19];
    }
    let t3;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <FontAwesomeIcon icon={faWarning} />;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    let t4;
    if ($[21] !== t) {
      t4 = t("bookmarks.noBookmarks");
      $[21] = t;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    let t5;
    if ($[23] !== t4) {
      t5 = <AlertTitle>{t4}</AlertTitle>;
      $[23] = t4;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    let t6;
    if ($[25] !== t) {
      t6 = t("bookmarks.noBookmarksMessage");
      $[25] = t;
      $[26] = t6;
    } else {
      t6 = $[26];
    }
    let t7;
    if ($[27] !== t6) {
      t7 = <AlertDescription>{t6}</AlertDescription>;
      $[27] = t6;
      $[28] = t7;
    } else {
      t7 = $[28];
    }
    let t8;
    if ($[29] !== t5 || $[30] !== t7) {
      t8 = <Alert variant="destructive">{t3}{t5}{t7}</Alert>;
      $[29] = t5;
      $[30] = t7;
      $[31] = t8;
    } else {
      t8 = $[31];
    }
    let t9;
    if ($[32] !== t2 || $[33] !== t8) {
      t9 = <div className="flex w-full flex-col gap-3 p-4">{t2}{t8}</div>;
      $[32] = t2;
      $[33] = t8;
      $[34] = t9;
    } else {
      t9 = $[34];
    }
    return t9;
  }
  let t1;
  if ($[35] !== t) {
    t1 = t("generic.bookmarks");
    $[35] = t;
    $[36] = t1;
  } else {
    t1 = $[36];
  }
  let t2;
  if ($[37] !== t1) {
    t2 = <h1 className="text-primary text-xl sm:text-2xl font-semibold tracking-tight">{t1}</h1>;
    $[37] = t1;
    $[38] = t2;
  } else {
    t2 = $[38];
  }
  let t3;
  if ($[39] !== bookmarks) {
    t3 = bookmarks.map(_temp);
    $[39] = bookmarks;
    $[40] = t3;
  } else {
    t3 = $[40];
  }
  let t4;
  if ($[41] !== t3) {
    t4 = <div className="flex flex-col gap-3">{t3}</div>;
    $[41] = t3;
    $[42] = t4;
  } else {
    t4 = $[42];
  }
  let t5;
  if ($[43] !== t2 || $[44] !== t4) {
    t5 = <div className="h-full space-y-5 overflow-y-auto p-4">{t2}{t4}</div>;
    $[43] = t2;
    $[44] = t4;
    $[45] = t5;
  } else {
    t5 = $[45];
  }
  return t5;
}
function _temp(bookmark) {
  if (!bookmark) {
    return null;
  }
  return <BookmarkEntry key={`block-${bookmark.blockIdentifier}-unit-${bookmark.unitId}`} block={bookmark.block} summary={"summary" in bookmark.block ? bookmark.block.summary : null} moduleTitle={bookmark.moduleTitle} unitTitle={bookmark.unitTitle} blockIdentifier={bookmark.blockIdentifier} courseId={bookmark.courseId} moduleId={bookmark.moduleId} unitId={bookmark.unitId} />;
}
export default SuspendedBookmarksList;